import { connect } from 'react-redux';
import _ from 'lodash';
import compose from 'lodash/fp/compose';
import { reduxForm, getFormValues } from 'redux-form';
import { REDUCER_NAME, fetchAuditLogs } from 'src/reducers/clients/auditLogs';
import {
  takeAuditLogsSearchQueries,
  takeAuditLogsSearchQueriesFromLocation,
  takeAuditLogsResetFormQueries,
  FORM_NAME_AUDIT_LOGS_SEARCH
} from 'src/reducers/searchForm';
import { getIsLoading } from 'src/reducers/common/listReducer';
import AuditLogsList from './components/AuditLogsList';

const mapStateToProps = state => ({
  initialValues: {
    ...takeAuditLogsSearchQueriesFromLocation(state.router.location),
    ...getFormValues(FORM_NAME_AUDIT_LOGS_SEARCH)(state)
  },
  reducerName: REDUCER_NAME,
  formName: FORM_NAME_AUDIT_LOGS_SEARCH,
  isListLoading: getIsLoading(REDUCER_NAME, state),
  resetValues: takeAuditLogsResetFormQueries(),
  location: state.router.location
});

const mapDispatchToProps = dispatch => ({
  searchAuditLogs: formValues => {
    // Does not execute fetchAuditLogs if startDate and endDate do not exist
    if (_.isUndefined(formValues.endDate) && formValues.startDate || _.isUndefined(formValues.startDate) && formValues.endDate) {
      return;
    } else {
      dispatch(fetchAuditLogs(takeAuditLogsSearchQueries(formValues)));
    }
  }
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORM_NAME_AUDIT_LOGS_SEARCH,
    enableReinitialize: true
  })
)(AuditLogsList);
